import { isMobile } from "react-device-detect";
import { Box, Button, Divider, IconButton, InputAdornment, OutlinedInput, Stack, Tooltip, Typography, useMediaQuery } from "@mui/material";
import React, { useEffect, useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import DepartmentTable from "./table";
import { Outlet, useNavigate } from "react-router";
import FilterAltOffIcon from "@mui/icons-material/FilterAltOff";
import CachedIcon from "@mui/icons-material/Cached";
import { useTheme } from "@mui/material/styles";
import Loader from "../../common/loader";
import { toast } from "react-toastify";
import { isLogin } from "../../../services/authService";
import { getTrainings } from "../../../services/trainingService";
import TrainingTable from "./table";

const { getDepartments } = require("../../../services/departmentService");

export default function Trainings() {
    const navigate = useNavigate();
    const [search, setSearch] = useState("");
    const [reload, setReload] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [trainings, setTrainings] = useState([]);
    const [filteredTrainings, setFilteredTrainings] = useState([]);

    useEffect(() => {
        document.title = "Techlogics | Trainings";
        if (!isLogin()) navigate("/admin-login");

        getTrainings()
            .then((res) => {
                setTrainings(res.data.data);
                setFilteredTrainings(res.data.data);
                setIsLoading(false);
            })
            .catch((err) => {
                console.log(err);
                setIsLoading(false);
            });
    }, [reload]);

    const handleSearch = (e) => {
        setSearch(e.target.value);
        if (e.target.value === "") {
            setFilteredTrainings(trainings);
        } else {
            const filtered = trainings.filter((training) => {
                return training.title.toLowerCase().includes(e.target.value.toLowerCase());
            });
            setFilteredTrainings(filtered);
        }
    };

    const handleClearSearch = () => {
        setSearch("");
        setFilteredTrainings(trainings);
    };

    const handleRefresh = () => {
        setSearch("");
        setIsLoading(true);
        setReload(!reload);
        toast.success("Trainings Refreshed");
    };

    return (
        <Box p={2} gap={2} sx={{ display: "flex", flexDirection: { xs: "column", sm: "row" } }}>
            <Box width={{ xs: "100%", sm: "90%" }}>
                <Stack direction={"row"} gap={1} alignItems={"center"}>
                    <Typography className='purple' variant='h6'>
                        Training List
                    </Typography>
                    <Tooltip title='Refresh' placement='right'>
                        <IconButton color='' size='small' onClick={handleRefresh}>
                            <CachedIcon />
                        </IconButton>
                    </Tooltip>
                </Stack>
                <Box py={1} sx={{ display: "flex", flexDirection: { xs: "column", sm: "row" }, gap: 1, alignItems: "center" }}>
                    <OutlinedInput
                        fullWidth
                        type='text'
                        placeholder='Search Training'
                        sx={{
                            flex: 1,
                        }}
                        size='small'
                        value={search}
                        onChange={handleSearch}
                        endAdornment={
                            <Tooltip title='Clear'>
                                <IconButton onClick={handleClearSearch}>
                                    <FilterAltOffIcon />
                                </IconButton>
                            </Tooltip>
                        }
                        startAdornment={
                            <InputAdornment position='start'>
                                <SearchIcon color='primary' sx={{ marginRight: 1 }} />
                            </InputAdornment>
                        }
                    />
                    <Button
                        // fullWidth={{ xs: true, md: false }}
                        size={isMobile ? "small" : "medium"}
                        variant='contained'
                        color=''
                        sx={{ color: "#30369e" }}
                        onClick={() => navigate("/admin/trainings/tab=5/add")}
                    >
                        Add Training
                    </Button>
                </Box>
                {isLoading && <Loader message={"Fetching trainings"} />}
                {!isLoading && <TrainingTable filteredTrainings={filteredTrainings} />}
            </Box>
            <Divider orientation={isMobile ? "horizontal" : "vertical"} flexItem />
            <Box width={"100%"} sx={{ xs: 0, sm: 1 }}>
                <Outlet />
            </Box>
        </Box>
    );
}
